import { MenuItem } from './menu.model';
 
export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENÚ',
        isTitle: true
    },
    {
        id: 2,
        label: 'DASHBOARD',
        icon: 'bx-home-circle',
        badge: {
            variant: 'info'
        },
        link: '/dashboard'
    },
    {
        id: 3,
        isLayout: true
    },
    {
        id: 4,
        label: 'CONFIGURACIÓN',
        icon: 'bx-cog',
        subItems: [
            {
                id: 5,
                label: 'Compañia',
                link: '/compañia',
                parentId: 4
            },
            {
                id: 6,
                label: 'Sucursal/Tienda',
                link: '/sucursales',
                parentId: 4
            },
            {
                id: 7,
                label: 'Almacén/Bodega',
                link: '/almacenes',
                parentId: 4
            },
            {
                id: 7,
                label: 'Vehículos',
                link: '/vehiculos',
                parentId: 65
            }
        ]
    },
    {
        id: 8,
        label: 'SECURIDAD',
        icon: 'bx-shield-quarter',
        subItems: [
            {
                id: 9,
                label: 'Permisos',
                link: '/permisos',
                parentId: 8
            },
            {
                id: 10,
                label: 'Usuarios',
                link: '/usuarios',
                parentId: 8
            }
        ]
    },
    {
        id: 11,
        label: 'PERSONAL',
        icon: 'bx-street-view',
        subItems: [
            {
                id: 12,
                label: 'Empleados',
                link: '/empleados',
                parentId: 11
            },
            {
                id: 13,
                label: 'Proveedores',
                link: '/proveedores',
                parentId: 11
            },
            {
                id: 14,
                label: 'Clientes',
                link: '/clientes',
                parentId: 11
            },
            {
                id: 49,
                label: 'Comisión s/ventas',
                link: '/comision-ventas',
                parentId: 11
            }
        ]
    },
    {
        id: 15,
        label: 'INVENTARIO',
        icon: 'bxs-component ',
        subItems: [
            {
                id: 16,
                label: 'División/Línea',
                link: '/divisiones',
                parentId: 15
            },
            {
                id: 17,
                label: 'Categorías',
                link: '/categorias',
                parentId: 15
            },
            {
                id: 18,
                label: 'Productos',
                link: '/productos',
                parentId: 15
            },
            {
                id: 19,
                label: 'Unidad Medida',
                link: '/unidad-medida',
                parentId: 15
            },
            {
                id: 20,
                label: 'Kardex',
                link: '/kardex',
                parentId: 15
            },
            {
                id: 21,
                label: 'Ajustes +/-',
                link: '/ajustes-inventario',
                parentId: 15
            },
            {
                id: 22,
                label: 'Requisición',
                link: '/requisiones-productos',
                parentId: 15
            }
        ]
    },
    {
        id: 23,
        label: 'COMPRAS',
        icon: 'bxs-cart',
        subItems: [
            {
                id: 24,
                label: 'Cotizaciones',
                link: '/cotizacion-compra',
                parentId: 23
            },
            {
                id: 25,
                label: 'Ordenes',
                link: '/orden-compra',
                parentId: 23
            },
            {
                id: 26,
                label: 'Registro',
                link: '/registro-compra',
                parentId: 23
            }
        ]
    },
    {
        id: 27,
        label: 'VENTAS',
        icon: 'bxs-receipt',
        subItems: [
            {
                id: 28,
                label: 'Cotizaciones',
                link: '/cotizacion-venta',
                parentId: 27
            },
            {
                id: 29,
                label: 'Registro',
                link: '/registro-venta',
                parentId: 27
            },
            {
                id: 30,
                label: 'Devolución',
                link: '/devolucion-venta',
                parentId: 27
            },
            {
                id: 31,
                label: 'Descuento Categoría',
                link: '/descuento-categoria',
                parentId: 27
            },
            {
                id: 59,
                label: 'Entregas Pendientes',
                link: '/entrega-productos',
                parentId: 27
            }
        ]
    },
    {
        id: 32,
        label: 'CAJA',
        icon: 'bxs-credit-card',
        subItems: [
            {
                id: 33,
                label: 'Cobro',
                link: '/cobro-caja',
                parentId: 32
            },
            {
                id: 34,
                label: 'Cierre',
                link: '/cierre-caja',
                parentId: 32
            }
        ]
    },
    /*{
        id: 35,
        label: 'TEMPLATES',
        icon: 'bx bx-columns',
        subItems: [
            {
                id: 36,
                label: 'TEMPLATES.LIST.DOWNLOAD',
                link: '/descargar-plantillas',
                parentId: 35
            },
            {
                id: 37,
                label: 'TEMPLATES.LIST.UPLOAD',
                link: '/subir-plantillas',
                parentId: 35
            }
        ]
    },*/
    {
        id: 38,
        label: 'FLETES',
        icon: 'bxs-truck',
        subItems: [
            {
                id: 39,
                label: 'Control Entregas',
                link: '/control-viajes',
                parentId: 38
            }
        ]
    },
    {
        id: 40,
        label: 'PLANILLA',
        icon: 'bx-receipt',
        subItems: [
            {
                id: 41,
                label: 'Tipo planilla',
                link: '/tipo-planilla',
                parentId: 40
            },
            {
                id: 42,
                label: 'Configurar planilla',
                link: '/configuracion-planilla',
                parentId: 40
            },
            {
                id: 43,
                label: 'Generar Pago',
                link: '/generar-planilla',
                parentId: 40
            },
            {
                id: 44,
                label: 'Agregar Ingreso/Deducción',
                link: '/agrega-ing-ded',
                parentId: 40
            }
        ]
    },
    {
        id: 45,
        label: 'PANEL DE CONSULTA',
        icon: 'bx-barcode',
        subItems: [
            {
                id: 46,
                label: 'Consulta Precios',
                link: '/consulta-precios',
                parentId: 45
            }
        ]
    },
    {
        id: 49,
        label: 'REPORTES',
        icon: 'bx-file',
        subItems: [
            {
                id: 50,
                label: 'Personal', 
                link: '/reporte_personal',
                parentId: 49
            },
            {
                id: 51,
                label: 'Inventario',
                link: '/reporte_inventario',
                parentId: 49
            },
            {
                id: 52,
                label: 'Compras',
                link: '/reporte_compras',
                parentId: 49
            },
            {
                id: 53,
                label: 'Ventas',
                link: '/reporte_ventas',
                parentId: 49
            },
            {
                id: 54,
                label: 'Caja',
                link: '/reporte_caja',
                parentId: 49
            },
            /*{
                id: 55,
                label: 'Planilla',
                link: '/reporte-planilla',
                parentId: 49
            },
            {
                id: 56,
                label: 'Requisiciones',
                link: '/reporte-requision',
                parentId: 49
            },*/
            {
                id: 68,
                label: 'Ingresos/Gastos', 
                link: '/rpt-contable',
                parentId: 49
            } 
        ]
    },
    {
        id: 57,
        label: 'CUENTAS POR COBRAR',
        icon: 'bx bxs-collection',
        subItems: [
            {
                id: 58,
                label: 'Créditos/Abonos', 
                link: '/abono_clientes',
                parentId: 57
            },
            {
                id: 64,
                label: 'Reporte de Pagos', 
                link: '/pago_clientes',
                parentId: 57
            }
        ]
    },
    {
        id: 63,
        label: 'CUENTAS POR PAGAR',
        icon: 'bx bxs-news',
        link: '/cuentas_por_pagar'
    },
    /*{
        id: 60,
        label: 'REGALIAS',
        icon: 'bx bx-basket',
        subItems: [
            {
                id: 61,
                label: 'Asignar Producto', 
                link: '/producto_regalia',
                parentId: 60
            },
            {
                id: 62,
                label: 'Canjear', 
                link: '/canje_regalia',
                parentId: 60
            }
        ]
    },*/
    {
        id: 66,
        label: 'Contabilidad',
        icon: 'bx bx-money',
        subItems: [
            {
                id: 67,
                label: 'Registro', 
                link: '/contabilidad',
                parentId: 66
            }
        ]
    },
    {
        id: 68,
        label: 'Manual de Usuario',
        icon: 'bx bxs-file-pdf',
        link: '/manual'
    },
];